export default __webpack_public_path__ + "static/media/new_6.dd594096.jpeg";